import { Link } from "react-router-dom";

export default function PoliticaPrivacidad() {
	return (
		<>
			<div className="container mx-auto px-4 h-full">
				<div className="flex content-start items-start justify-center h-full">
					<div className="w-full lg:w-10/12 px-4 -mt-20">
						<div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
							<div className="rounded-t mb-0 px-6 py-6 border-b border-blueGray-100">
								<h1 className="text-2xl font-bold text-blueGray-800">
									Politica de Privacidad de ENARM Apex
								</h1>
								<p className="text-sm text-blueGray-500 mt-2">
									Ultima actualizacion: 21 de julio de 2026
								</p>
							</div>

							<div className="flex-auto px-6 lg:px-10 py-8 text-blueGray-700 text-sm leading-relaxed space-y-6">
								<p>
									ENARM Apex, con correo de contacto soporte@enarmapex.com, es responsable del tratamiento de los datos personales que recabamos a traves de nuestro sitio web, aplicacion web, servicios digitales, formularios, sistema de autenticacion, sistema de pagos y herramientas relacionadas con la plataforma ENARM Apex.
								</p>

								<p>
									Esta Politica de Privacidad explica que informacion recopilamos, como la usamos, con quien la compartimos, como la protegemos y que derechos tienen los usuarios respecto de sus datos personales.
								</p>

								<p>
									ENARM Apex es una plataforma educativa disenada para apoyar la preparacion del Examen Nacional de Aspirantes a Residencias Medicas. El contenido de la plataforma tiene fines exclusivamente educativos y no constituye consejo medico, diagnostico, tratamiento, consulta profesional ni sustituto de la valoracion de un profesional de la salud.
								</p>

								<section>
									<h2 className="text-lg font-semibold text-blueGray-800 mb-3">
										1. Datos personales que recopilamos
									</h2>

									<h3 className="font-semibold text-blueGray-700 mb-2">Datos de cuenta</h3>
									<ul className="list-disc pl-6 space-y-1 mb-4">
										<li>Nombre completo.</li>
										<li>Correo electronico.</li>
										<li>Foto o avatar de perfil, cuando el usuario la proporcione.</li>
										<li>Identificador de usuario.</li>
										<li>Estado de suscripcion.</li>
										<li>Fecha de creacion y actualizacion de la cuenta.</li>
									</ul>

									<h3 className="font-semibold text-blueGray-700 mb-2">Datos de uso academico</h3>
									<p className="mb-2">
										Para operar las funciones de ENARM Apex, podemos recopilar informacion relacionada con el uso de la plataforma, incluyendo:
									</p>
									<ul className="list-disc pl-6 space-y-1 mb-4">
										<li>Simuladores creados.</li>
										<li>Simuladores completados.</li>
										<li>Numero de preguntas respondidas.</li>
										<li>Respuestas seleccionadas.</li>
										<li>Respuestas correctas e incorrectas.</li>
										<li>Puntajes obtenidos.</li>
										<li>Tiempo utilizado en preguntas, simuladores o sesiones.</li>
										<li>Sesiones de practica creadas o finalizadas.</li>
										<li>Flashcards revisadas.</li>
										<li>Calificacion de recuerdo en flashcards: otra vez, dificil, bien o facil.</li>
										<li>Progreso por especialidad, seccion, tema o modulo.</li>
										<li>Preguntas marcadas como favoritas.</li>
										<li>Historial de actividad reciente.</li>
										<li>Estadisticas de desempeno.</li>
									</ul>

									<h3 className="font-semibold text-blueGray-700 mb-2">Datos de pago y suscripcion</h3>
									<p className="mb-2">
										Los pagos de ENARM Apex se procesan mediante Stripe. Podemos almacenar identificadores relacionados con el pago, como:
									</p>
									<ul className="list-disc pl-6 space-y-1 mb-2">
										<li>ID de cliente de Stripe.</li>
										<li>ID de suscripcion de Stripe.</li>
										<li>Tipo de plan contratado.</li>
										<li>Estado de la suscripcion.</li>
										<li>Fecha de inicio y termino del periodo de prueba.</li>
										<li>Fecha de renovacion.</li>
										<li>Estado de cancelacion.</li>
									</ul>
									<p>
										ENARM Apex no almacena directamente los datos completos de tarjetas bancarias. La informacion de pago se procesa mediante Stripe, proveedor externo de pagos. Stripe puede tratar datos personales relacionados con pagos, datos de contacto, metodo de pago y transacciones conforme a su propia politica de privacidad.
									</p>

									<h3 className="font-semibold text-blueGray-700 mt-4 mb-2">Datos tecnicos</h3>
									<p className="mb-2">
										Tambien podemos recopilar informacion tecnica necesaria para seguridad, funcionamiento y mejora de la plataforma, como:
									</p>
									<ul className="list-disc pl-6 space-y-1">
										<li>Direccion IP.</li>
										<li>Tipo de navegador.</li>
										<li>Sistema operativo.</li>
										<li>Dispositivo utilizado.</li>
										<li>Fecha y hora de acceso.</li>
										<li>Registros de errores.</li>
										<li>Informacion de sesion.</li>
										<li>Cookies o tecnologias similares.</li>
									</ul>
								</section>

								<section>
									<h2 className="text-lg font-semibold text-blueGray-800 mb-3">
										2. Datos personales sensibles
									</h2>
									<p className="mb-2">
										ENARM Apex no solicita datos personales sensibles para operar la plataforma.
									</p>
									<p className="mb-2">
										Aunque la plataforma contiene casos clinicos, preguntas medicas y material educativo, estos contenidos estan disenados con fines academicos. El usuario no debe ingresar informacion real de pacientes, expedientes clinicos, datos de salud identificables, imagenes clinicas reales con datos personales, ni cualquier informacion medica privada de terceros.
									</p>
									<p>
										Si el usuario decide ingresar voluntariamente datos sensibles en notas, flashcards, preguntas personalizadas, formularios de contacto o cualquier otro campo libre, dichos datos seran tratados unicamente para prestar el servicio solicitado. Recomendamos no ingresar datos personales sensibles ni informacion identificable de pacientes.
									</p>
								</section>

								<section>
									<h2 className="text-lg font-semibold text-blueGray-800 mb-3">
										3. Finalidades del tratamiento de datos
									</h2>
									<p className="mb-2">
										Usamos los datos personales para las siguientes finalidades principales:
									</p>
									<ul className="list-disc pl-6 space-y-1 mb-2">
										<li>Crear y administrar cuentas de usuario.</li>
										<li>Autenticar el acceso a la plataforma.</li>
										<li>Permitir el uso de simuladores.</li>
										<li>Permitir sesiones de practica.</li>
										<li>Permitir sesiones de flashcards.</li>
										<li>Guardar progreso academico.</li>
										<li>Calcular estadisticas de desempeno.</li>
										<li>Mostrar historial de actividad reciente.</li>
										<li>Personalizar la experiencia del usuario.</li>
										<li>Gestionar planes, pagos, suscripciones y periodos de prueba.</li>
										<li>Atender solicitudes de soporte.</li>
										<li>Prevenir abuso, fraude, accesos no autorizados o uso indebido.</li>
										<li>Mantener la seguridad y estabilidad del servicio.</li>
										<li>Cumplir obligaciones legales, fiscales o regulatorias aplicables.</li>
									</ul>
									<p>
										Tambien podemos usar informacion agregada o anonimizada para mejorar el contenido educativo, analizar metricas generales de uso y optimizar la plataforma.
									</p>
								</section>

								<section>
									<h2 className="text-lg font-semibold text-blueGray-800 mb-3">
										4. Finalidades secundarias
									</h2>
									<p className="mb-2">Podemos usar tus datos para finalidades secundarias como:</p>
									<ul className="list-disc pl-6 space-y-1 mb-2">
										<li>Enviar noticias, actualizaciones o mejoras de ENARM Apex.</li>
										<li>Enviar comunicaciones promocionales.</li>
										<li>Solicitar retroalimentacion sobre la plataforma.</li>
										<li>Realizar analisis internos de producto.</li>
									</ul>
									<p>
										El usuario puede oponerse a estas finalidades secundarias enviando un correo a [correo@enarmapex.com].
									</p>
								</section>

								<section>
									<h2 className="text-lg font-semibold text-blueGray-800 mb-3">
										5. Base de datos, autenticacion e infraestructura
									</h2>
									<p className="mb-2">
										ENARM Apex utiliza servicios tecnologicos de terceros para operar la plataforma. Actualmente podemos utilizar proveedores como:
									</p>
									<ul className="list-disc pl-6 space-y-1 mb-2">
										<li>Supabase, para autenticacion, base de datos, almacenamiento y funciones backend.</li>
										<li>Stripe, para procesamiento de pagos y suscripciones.</li>
										<li>Cloudflare, para alojar la aplicacion.</li>
										<li>Resend, para comunicaciones transaccionales.</li>
									</ul>
									<p>
										Supabase proporciona controles de seguridad como Row Level Security en PostgreSQL para restringir el acceso a filas de datos segun politicas definidas por la aplicacion. La seguridad final tambien depende de la correcta configuracion de la aplicacion, permisos, politicas y reglas implementadas por ENARM Apex.
									</p>
								</section>

								<section>
									<h2 className="text-lg font-semibold text-blueGray-800 mb-3">
										6. Transferencias de datos
									</h2>
									<p className="mb-2">
										Podemos compartir datos personales con terceros unicamente cuando sea necesario para operar ENARM Apex, por ejemplo:
									</p>
									<ul className="list-disc pl-6 space-y-1 mb-2">
										<li>Procesadores de pago.</li>
										<li>Proveedores de infraestructura tecnologica.</li>
										<li>Proveedores de autenticacion, base de datos o almacenamiento.</li>
										<li>Proveedores de correo electronico o soporte.</li>
										<li>Autoridades competentes, cuando exista una obligacion legal.</li>
									</ul>
									<p className="mb-2">
										Algunos proveedores pueden encontrarse fuera de Mexico, por lo que los datos pueden ser tratados o almacenados en otros paises. En estos casos, procuraremos que los proveedores cuenten con medidas razonables de seguridad y proteccion de datos.
									</p>
									<p>No vendemos tus datos personales a terceros.</p>
								</section>

								<section>
									<h2 className="text-lg font-semibold text-blueGray-800 mb-3">
										7. Conservacion de datos
									</h2>
									<p className="mb-2">
										Conservaremos los datos personales durante el tiempo necesario para cumplir las finalidades descritas en esta Politica de Privacidad, incluyendo:
									</p>
									<ul className="list-disc pl-6 space-y-1 mb-2">
										<li>Mantener activa la cuenta del usuario.</li>
										<li>Guardar historial academico y progreso.</li>
										<li>Cumplir obligaciones legales o fiscales.</li>
										<li>Resolver disputas.</li>
										<li>Prevenir fraude o abuso.</li>
										<li>Atender solicitudes de soporte.</li>
									</ul>
									<p>
										Cuando una cuenta sea eliminada, podremos conservar ciertos datos durante el tiempo requerido por ley o por razones legitimas de seguridad, auditoria o cumplimiento. Cuando sea posible, los datos podran ser eliminados, bloqueados o anonimizados.
									</p>
								</section>

								<section>
									<h2 className="text-lg font-semibold text-blueGray-800 mb-3">
										8. Seguridad de la informacion
									</h2>
									<p className="mb-2">
										Implementamos medidas administrativas, tecnicas y organizativas razonables para proteger los datos personales contra perdida, uso indebido, acceso no autorizado, divulgacion, alteracion o destruccion.
									</p>
									<p className="mb-2">Entre estas medidas pueden incluirse:</p>
									<ul className="list-disc pl-6 space-y-1 mb-2">
										<li>Autenticacion de usuarios.</li>
										<li>Control de acceso por usuario.</li>
										<li>Politicas de seguridad en base de datos.</li>
										<li>Uso de proveedores especializados.</li>
										<li>Monitoreo de errores y actividad sospechosa.</li>
										<li>Restriccion de acceso a informacion sensible.</li>
										<li>Uso de conexiones seguras cuando sea aplicable.</li>
									</ul>
									<p>
										Sin embargo, ningun sistema es completamente seguro. El usuario tambien es responsable de mantener la confidencialidad de sus credenciales de acceso.
									</p>
								</section>

								<section>
									<h2 className="text-lg font-semibold text-blueGray-800 mb-3">
										9. Derechos ARCO
									</h2>
									<p className="mb-2">El usuario puede ejercer sus derechos de:</p>
									<ul className="list-disc pl-6 space-y-1 mb-2">
										<li>Acceso: conocer que datos personales tenemos.</li>
										<li>Rectificacion: solicitar la correccion de datos inexactos.</li>
										<li>Cancelacion: solicitar la eliminacion de datos cuando proceda.</li>
										<li>Oposicion: oponerse al tratamiento de sus datos para ciertas finalidades.</li>
									</ul>
									<p className="mb-2">Para ejercer estos derechos, el usuario puede enviar una solicitud a:</p>
									<p className="font-semibold mb-2">[correo@enarmapex.com]</p>
									<p className="mb-2">La solicitud debera incluir:</p>
									<ul className="list-disc pl-6 space-y-1">
										<li>Nombre completo.</li>
										<li>Correo asociado a la cuenta.</li>
										<li>Derecho que desea ejercer.</li>
										<li>Descripcion clara de la solicitud.</li>
										<li>Medio para recibir respuesta.</li>
										<li>Documento o mecanismo razonable para acreditar identidad, cuando sea necesario.</li>
									</ul>
									<p className="mt-2">Responderemos dentro de los plazos establecidos por la legislacion aplicable.</p>
								</section>

								<section>
									<h2 className="text-lg font-semibold text-blueGray-800 mb-3">
										10. Revocacion del consentimiento
									</h2>
									<p>
										El usuario puede revocar su consentimiento para el tratamiento de sus datos personales cuando legalmente sea procedente. La revocacion puede implicar que ciertas funciones de ENARM Apex dejen de estar disponibles, especialmente aquellas relacionadas con cuenta, progreso, estadisticas, pagos o acceso personalizado.
									</p>
								</section>

								<section>
									<h2 className="text-lg font-semibold text-blueGray-800 mb-3">
										11. Limitacion del uso o divulgacion de datos
									</h2>
									<p className="mb-2">
										El usuario puede solicitar que limitemos el uso o divulgacion de sus datos personales para finalidades secundarias, como comunicaciones promocionales.
									</p>
									<p>Para hacerlo, puede escribir a: [correo@enarmapex.com]</p>
								</section>

								<section>
									<h2 className="text-lg font-semibold text-blueGray-800 mb-3">
										12. Cookies y tecnologias similares
									</h2>
									<p className="mb-2">
										ENARM Apex puede utilizar cookies, almacenamiento local, tokens de sesion o tecnologias similares para:
									</p>
									<ul className="list-disc pl-6 space-y-1 mb-2">
										<li>Mantener la sesion iniciada.</li>
										<li>Recordar preferencias del usuario.</li>
										<li>Mejorar la seguridad.</li>
										<li>Analizar funcionamiento del sitio.</li>
										<li>Mejorar la experiencia de navegacion.</li>
									</ul>
									<p>
										El usuario puede configurar su navegador para bloquear o eliminar cookies. Sin embargo, algunas funciones de la plataforma podrian no funcionar correctamente.
									</p>
								</section>

								<section>
									<h2 className="text-lg font-semibold text-blueGray-800 mb-3">
										13. Pagos, periodo de prueba y suscripciones
									</h2>
									<p className="mb-2">ENARM Apex puede ofrecer planes de suscripcion, incluyendo:</p>
									<ul className="list-disc pl-6 space-y-1 mb-2">
										<li>Plan mensual.</li>
										<li>Plan anual.</li>
										<li>Periodo de prueba gratuito.</li>
									</ul>
									<p>
										Para iniciar una prueba o suscripcion, el usuario puede ser redirigido a Stripe para ingresar su informacion de pago. Despues del periodo de prueba, Stripe podra realizar el cargo correspondiente conforme al plan seleccionado, salvo que el usuario cancele antes del termino del periodo de prueba.
									</p>
									<p className="mt-2">
										La gestion de pagos, tarjetas, facturacion y suscripciones puede estar sujeta tambien a los terminos y politicas de Stripe.
									</p>
								</section>

								<section>
									<h2 className="text-lg font-semibold text-blueGray-800 mb-3">
										14. Usuarios menores de edad
									</h2>
									<p>
										ENARM Apex esta dirigido principalmente a estudiantes, medicos y profesionales relacionados con la preparacion del ENARM. La plataforma no esta dirigida a menores de edad. Si detectamos que hemos recopilado datos de un menor de edad sin autorizacion correspondiente, podremos eliminar dicha informacion.
									</p>
								</section>

								<section>
									<h2 className="text-lg font-semibold text-blueGray-800 mb-3">
										15. Contenido educativo y responsabilidad medica
									</h2>
									<p className="mb-2">
										El contenido de ENARM Apex tiene fines educativos y de preparacion academica. Aunque puede incluir informacion medica, casos clinicos, preguntas tipo examen, explicaciones y referencias, no debe interpretarse como:
									</p>
									<ul className="list-disc pl-6 space-y-1 mb-2">
										<li>Consejo medico personalizado.</li>
										<li>Diagnostico.</li>
										<li>Tratamiento.</li>
										<li>Recomendacion clinica individual.</li>
										<li>Sustituto de guias oficiales, criterio medico o atencion profesional.</li>
									</ul>
									<p>
										El usuario es responsable de verificar la informacion con fuentes oficiales, guias clinicas vigentes y criterio profesional.
									</p>
								</section>

								<section>
									<h2 className="text-lg font-semibold text-blueGray-800 mb-3">
										16. Cambios a esta Politica de Privacidad
									</h2>
									<p className="mb-2">
										Podemos modificar esta Politica de Privacidad en cualquier momento para reflejar cambios legales, tecnicos, operativos o comerciales.
									</p>
									<p className="mb-2">Cuando realicemos cambios importantes, podremos notificar al usuario mediante:</p>
									<ul className="list-disc pl-6 space-y-1 mb-2">
										<li>Publicacion en el sitio web.</li>
										<li>Mensaje dentro de la plataforma.</li>
										<li>Correo electronico.</li>
										<li>Aviso visible al iniciar sesion.</li>
									</ul>
									<p>La fecha de ultima actualizacion aparecera al inicio de este documento.</p>
								</section>

								<section>
									<h2 className="text-lg font-semibold text-blueGray-800 mb-3">
										17. Contacto
									</h2>
									<p className="mb-2">
										Para dudas, solicitudes o ejercicio de derechos relacionados con datos personales, el usuario puede contactarnos en:
									</p>
									<ul className="list-disc pl-6 space-y-1">
										<li>Correo: soporteo@enarmapex.com</li>
										<li>Sitio web: https://enarmapex.com</li>
									</ul>
								</section>
							</div>

							<div className="px-6 lg:px-10 pb-8">
								<Link
									to="/auth/register"
									className="text-sm font-semibold text-lightBlue-500 hover:text-lightBlue-600"
								>
									Volver al registro
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
